
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 2118 1921.8"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"escena_x5F_path"}},[_c('path',{attrs:{"id":"escenario_x5F_4_x5F_path","d":"M2116.7 609.9L1059.4.3 2 610.8l.1 697.6 1057.4 610.5 1057.2-610.5V609.9z","opacity":".15","fill":"#fff"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_12","fill":"rgb(10,10,10,0.2)","d":"M247.9 833.1h323.4v211.7H247.9z"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_13","fill":"rgb(10,10,10,0.2)","d":"M1111.5 629.6h341.6V820h-341.6z"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_14","fill":"rgb(10,10,10,0.2)","d":"M576.6 1425.2h338.1v196.2H576.6z"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_15","fill":"rgb(10,10,10,0.2)","d":"M1411.4 839.5h322.7v249h-322.7z"}})])])
          )
        }
      }
    